import * as React from "react";

import { cn } from "@/lib/utils";

interface AuthLayoutProps {
  children: React.ReactNode;
  side?: React.ReactNode;
  className?: string;
}

/**
 * Provides consistent framing for public/auth pages with brand background
 * and optional marketing/support side content.
 */
export function AuthLayout({ children, side, className }: AuthLayoutProps) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[color:var(--rf-color-primary)] text-white">
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.12),transparent_35%),radial-gradient(circle_at_80%_0%,rgba(0,0,0,0.18),transparent_45%)]"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/10 to-transparent"
      />

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col px-4 py-10 sm:px-6 lg:px-8">
        <div
          className={cn(
            "grid w-full gap-8",
            side ? "lg:grid-cols-[1.05fr,0.95fr]" : "max-w-xl place-self-center",
          )}
        >
          {side ? <div className="hidden text-white/90 lg:block">{side}</div> : null}
          <div className={cn("w-full", className)}>{children}</div>
        </div>
      </div>
    </div>
  );
}
